<!--
  name : 김혜진
  desc :
  date : 2020-11-25
-->
<template>
<v-row>
  <v-dialog
      v-model="poPcpnPoint"
      max-width="1200px"
      persistent>
      <v-card id="popStyle03">
        <!--팝업 제목-->
        <v-card-title class="title">
          요금 현황
          <v-btn fab class="popBtnClose" @click="poPcpnPoint = false"></v-btn>
        </v-card-title>
        <!--/팝업 제목-->
        <!--팝업 내용-->
        <v-card-text>
          <v-row no-gutters class="justify-center popCon">
            <v-col cols="12" class="posiR ta_left">
              <div class="feepay_round_box">
                <ul class="pattern_ulTxtBox minH24">
                  <li>
                    <!--conFrom:개인, conFrom st_cpn:기업-->
                    <v-chip class="conFrom st_cpn">기업</v-chip>
                    <span class="txt_txt01 no_pr">{{companyName}}</span>
                    <span class="txt_txt02">({{comRegno | regNumFilter}})</span>
                  </li>
                  <li>
                    <span class="txt_tt">기업 관리자</span>
                    <span class="txt_txt02">{{ comPanyUsr }}</span>
                  </li>
                  <li>
                    <span class="txt_icon">사용 가능 건수</span>
                    <span class="txt_txt02">{{ currCash | moneyWithComma }} 건</span>
                  </li>
                </ul>
              </div>
            </v-col>
            <!--기간검색바-->
            <v-row no-gutters>
              <v-col cols="12" sm="3" md="3" lg="2" class="pr-4">
                <v-select class="inputH48_02 Wm240xx dpnone"
                  v-model="searchData.History"
                  :items="items"
                  item-value="value"
                  item-text="label"
                  outlined
                  dense
                  >
                </v-select>
              </v-col>          
              <v-col cols="12" sm="7" md="6" lg="8">
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                  >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field class="inputH48_02 calendar_at calendar_W for_feepay dpnone"
                      v-model="dateRangeText"
                      label="기간"
                      prepend-icon="mdi-calendar"
                      readonly
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dates"
                      range
                      locale="ko-ko"
                    >
                    <v-spacer></v-spacer>
                    <v-btn class="btn18_00"
                      outlined
                      @click="$refs.menu.save(dates)"
                    >
                      확인
                    </v-btn>
                    <v-btn class="btn18_00"
                      outlined
                      @click="menu = false"
                    >
                      취소
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                <v-checkbox class="coNlist_chk size_s"
                  label="기간 전체"
                  value="1"
                  hide-details
                  v-model="searchData.ChkDateYn" @change="handlCheckedDate"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" class="ta_right mb_left cols_row_mt-6">
                <v-btn class="btn17_C01" @click="search"><span class="icon search"></span></v-btn>
              </v-col>
            </v-row>
        <!--/기간검색바-->
        <!--리스트-->
        <v-row no-gutters class="feepay_list" v-if="this.isView === 'C'">
          <v-col cols="12">
            <!--반복: 리스트 카드 : 최대 10개-->
            <v-card class="feepay_carD"  v-for="(point, index) of pointList" :key="index" >
                <v-list-item class="carD_box_clB">
                  <div class="carD_01">
                    <div class="feepay_chip">
                      <span class="st02" v-if="point.codeName === '신용카드'">신용카드</span>
                      <span class="st01" v-else-if="point.codeName === '휴대폰'">휴대폰</span>
                      <span class="st03" v-else-if="point.codeName === '계좌이체'">계좌이체</span>
                    </div>
                    <div class="carD_01_txt">
                      <!--결제금액--><span class="st_tt_01">{{point.payAmt === null?"": point.payAmt| moneyCurrency}}</span>
                      <!--충전건수--><span class="st_pay02">[건수] {{point.chrgPoint === null?"": getCount(point.chrgPoint, point.chrgTime) }}</span>
                    </div>                
                    <div class="dateBox">
                      <span class="st_txt">{{ getDate(point.chrgTime) }}</span>
                    </div>
                  </div>
                  <v-btn text class="btn17_C01" v-if="point.codeName === '신용카드'"  @click="cardReceiepts(point.chargeSeq)"><span class="icon card"></span><span class="card_txt">카드전표조회</span></v-btn>
                </v-list-item>
            </v-card>
            <!--리스트 카드-->
          </v-col>
        </v-row>
        <!--/리스트-->
        <v-row no-gutters class="feepay_list" v-else>
          <v-col cols="12">
            <!--반복: 리스트 카드 : 최대 10개-->
            <v-card class="feepay_carD st_cpn"  v-for="(use, index) of useList" :key="index" >
                <v-list-item class="carD_box_clB">
                  <div class="carD_01 W100">
                    <div class="carD_01_txt">
                      <!--사용--><span class="st_tt_01">{{ use.useTypeName }}</span>
                      <!--사용건수--><span class="st_pay">{{ use.useAmt === null?"": "사용 " }}</span> <span class="st_pay02">{{ use.useAmt === null?"": getCount(use.useAmt, use.cdate) }}</span>
                      <!--환불건수--><span class="st_bak">{{ use.rfndAmt === null?"": "환불 " }}</span> <span class="st_pay02">{{ use.rfndAmt === null?"": getCount(use.rfndAmt, use.cdate) }}</span>
                      <!--소멸건수--><span class="st_dis">{{ use.cnclAmt === null?"": "소멸 " }}</span> <span class="st_pay02">{{ use.cnclAmt === null?"": getCount(use.cnclAmt, use.cdate) }}</span>
                    </div>                
                    <div class="dateBox">
                      <span class="st_txt">{{ getDate(use.cdate) }}</span>
                    </div>
                  </div>
                </v-list-item>
            </v-card>
            <!--리스트 카드-->
          </v-col>
        </v-row>
        
        <!--페이지-->
        <v-row no-gutters class="justify-center row_mt-20">
          <v-pagination
            v-model="page"
            :length="total"
            @input="handlePageChange"
            total-visible="7"
            circle
          ></v-pagination>
        </v-row>
        <!--/페이지-->
          </v-row>
        </v-card-text>
        <!--/팝업 내용-->
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn text @click="poPcpnPoint = false">닫기</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-dialog>
    <s-confirm ref="confirm"></s-confirm>
  	<s-loading ref="loading"></s-loading>
    <!--/팝업-->
    </v-row>
</template>
<script>
import { getChargeList, getUseList, getCardreceipt } from '@/api/payment/fee'

export default {
  name: 'user',
  components: {
  },
  props: {
    // 체인주소
    chainAddr: String,
    // 개인,기업,연동
    isType: String,
    companyName: String,
    comRegno: String,
    currCash: Number,
    comPanyUsr: String
  },
  filters: {
    pointCurrency: value => {
      if (!value) return ''
      return value.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,') + 'P'
    },
    moneyCurrency: value => {
      if (!value) return ''
      return value.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,') + '원'
    },
    regNumFilter: function (value) {
      if (value) {
        return String(value).replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3')
      }
    },
    moneyWithComma: function (money) {
      if (String(money)) {
        return String(money).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    }
  },
  data () {
    return {
      // date picker
      poPcpnPoint: false,
      menu: false,
      isChecked: false,
      items: [{ value:'ChargeList', label:'충전내역' }, { value:'UseList', label:'사용내역' }],
      pointList: null,
      useList: null,
      dates: [],
      searchData: {
        History: 'ChargeList',
        ChkDateYn: false,
        fromDateValue: '',
        toDateValue: ''
      },
      pageParam: {
        page: 0,
        size: 10
      },
      page: 1,
      isView: '',
      total: 0,
      totalCnt: 0,
      targetUrl: process.env.VUE_APP_URL_CASH_RECEIPT,
      pgReceiptLink: process.env.VUE_APP_PG_RECEIPT_LINK,
      LGD_MID: '',
      LGD_TID: '',
      authdata: '',
      reciptUrl: '',
    }
  },
  computed: {
    dateRangeText () {
      if(this.dates.length === 2) {
        var start = this.dates[0]
        var end = this.dates[1]
        if(start > end) {
          this.dayChange(start, end)
          return this.dates.join(' ~ ')
        }else{
          return this.dates.join(' ~ ')
        }
      }else {
        return this.dates.join(' ~ ')
      }
    },
  },
  created () {
  },
  mounted () {
    
  },
  methods: {
    open() {
      this.poPcpnPoint = true
      this.$nextTick(() => {
        this.setSearchInfo()
        this.defaultSetting()
        this.search()
      })
    },
    defaultSetting () {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() +1;
      month = month >= 10 ? month : '0' + month;
      var day = date.getDate();
      day = day >= 10 ? day : '0' + day;
      var lastMonth = month -1
      var lastyear = date.getFullYear();
      if(month === '01') {
        lastMonth = '12'
        lastyear = year -1
      }
      var start = lastyear + '-' + lastMonth + '-' + day;
      var end =  year + '-' + month + '-' + day;

      this.dates = [start,end];
      return this.dates.join(' ~ ')

    },
    dayChange(start, end) {
      this.dates = [end, start]
    },
    setSearchInfo () {
      this.pageParam.page = 0
      // console.log(this.pointList + '널전')
      this.pointList = []
      this.useList = []
      // console.log(this.pointList + '널후')
      this.searchData.ChkDateYn = false
      this.searchData.History = 'ChargeList'
      this.isChecked = false
    },
    handlCheckedDate () {
      if (this.searchData.ChkDateYn === "1") {
        this.isChecked = true
      } else {
        this.isChecked = false
      }
    },
    // 검색 함수
    search () {
      this.pageParam.page = 0
      if (this.searchData.History === 'ChargeList') {
        this.isView = 'C'
        this.getChargeList()
      } else {
        this.isView = 'U'
        this.getUseList()
      }
    },
    handlePageChange(value) {
      this.pageParam.page = (value - 1)
      if (this.isView === 'C') {
        this.getChargeList()
      } else {
        this.getUseList()
      }
    },
    // 충전 내역 리스트
    getChargeList () {
      getChargeList({ chainAddr: this.chainAddr, isType: this.isType, pageParams: this.pageParam, fromDate: this.dates[0], toDate: this.dates[1], ChkDateYn: this.isChecked }).then(response => {
        this.pointList = response.rdata.list
        this.totalCnt = response.rdata.totalCnt
        var a = 0
        if(parseInt(response.rdata.totalCnt % 10) > 0) {
          a = 1
        }
        this.total = parseInt(response.rdata.totalCnt / 10) + a
      })
    },
    // 사용 내역 리스트
    getUseList () {
      getUseList({ chainAddr: this.chainAddr, isType: this.isType, pageParams: this.pageParam, fromDate: this.dates[0], toDate: this.dates[1], ChkDateYn: this.isChecked }).then(response => {
        this.useList = response.rdata.list
        this.totalCnt = response.rdata.totalCnt
        var a = 0
        if(parseInt(response.rdata.totalCnt % 10) > 0) {
          a = 1
        }
        this.total = parseInt(response.rdata.totalCnt / 10) + a
      })
    },
    cardReceiepts (cSeq) {
      getCardreceipt({ chargeSeq: cSeq, signal: 'company' }, this.targetUrl).then(response => {
        if (response.rdata.LGD_TID && response.rdata.LGD_TID !== '') {
          this.LGD_MID = response.rdata.LGD_MID
          this.LGD_TID = response.rdata.LGD_TID
          this.authdata = response.rdata.authdata
          this.reciptUrl = 'javascript:showReceiptByTID("' + this.LGD_MID + '" , "' + this.LGD_TID + '" , "' + this.authdata + '")'
          location.href = this.reciptUrl
        } else {
          this.$refs.confirm.open('alert', '결재정보', '카드 전표조회를 위한 결제정보가 없습니다. 관리자에게 문의해주세요.')
        }
      })
    },
    getDate(date) {
      var date1 = new Date(date)
      var year = date1.getFullYear()
      var month = date1.getMonth() +1
      month = month >= 10 ? month : '0' + month
      var day = date1.getDate()
      day = day >= 10 ? day : '0' + day
      var hour = date1.getHours()
      var minutes = date1.getMinutes()
      var second = date1.getSeconds()
      var end =  year + '-' + month + '-' + day + ' '+hour+':'+minutes+':'+second
      return end
    },
    getCount(amount, date) {   

      amount = parseInt(amount / 3000) +'건'
      
      return amount
    }
  }
}
</script>
<style scoped>
</style>
